import * as S from "./styles";

interface WhoWinsProps {
  homeTeamPercentage: number;
  awayTeamPercentage: number;
  draw: number;
}

export default function WhoWins({
  homeTeamPercentage=0,
  awayTeamPercentage=0,
  draw=0,
}: WhoWinsProps) {
  return (
    <>
      <S.PercentageContainer>
        <h3>Quem vai ganhar?</h3>
        <S.PercentageAnalysis
          greenTeam={homeTeamPercentage}
          blueTeam={awayTeamPercentage}
          draw={draw}
        >
          <div>
            <p>{homeTeamPercentage}%</p>
          </div>
          <div>
            <p>{draw}%</p>
          </div>
          <div>
            <p>{awayTeamPercentage}%</p>
          </div>
        </S.PercentageAnalysis>
      </S.PercentageContainer>
    </>
  );
}
